// API configuration
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 
  (import.meta.env.PROD ? 'https://asf-missing-child-protocol-api-002.primesites.workers.dev' : 'http://localhost:8787')

export interface User {
  id: number
  email: string
  name: string
  roles: string[]
}

export interface LoginResponse {
  message: string
  user: User
}

export const api = {
  baseUrl: API_BASE_URL,
  
  async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const url = `${API_BASE_URL}${endpoint}`
    
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      credentials: 'include', // Include cookies for session management
    })

    if (!response.ok) {
      const error = await response.json().catch(() => ({ message: 'Request failed' }))
      throw new Error(error.message || `HTTP ${response.status}`)
    }

    return response.json()
  },

  get<T>(endpoint: string): Promise<T> {
    return this.request<T>(endpoint, { method: 'GET' })
  },

  post<T>(endpoint: string, data?: any): Promise<T> {
    return this.request<T>(endpoint, {
      method: 'POST',
      body: data ? JSON.stringify(data) : undefined,
    })
  },

  put<T>(endpoint: string, data?: any): Promise<T> {
    return this.request<T>(endpoint, {
      method: 'PUT',
      body: data ? JSON.stringify(data) : undefined,
    })
  },

  delete<T>(endpoint: string): Promise<T> {
    return this.request<T>(endpoint, { method: 'DELETE' })
  },

  // Authentication methods
  async requestOtp(email: string): Promise<{ message: string }> {
    return this.post('/api/auth/verify-email', { email })
  },

  async verifyOtp(email: string, otp: string): Promise<User> {
    const response = await this.post<LoginResponse>('/api/auth/verify-otp', { email, otp })
    return response.user
  },

  async logout(): Promise<{ message: string }> {
    return this.post('/api/auth/logout')
  },

  async getCurrentUser(): Promise<User> {
    return this.get<User>('/api/auth/me')
  },
}

export default api
